/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_List_No_Artifacts_TitleInputs */



/**
* | output |
* | --- |
* | "No artifacts yet" |
*
* @param {Artifact_List_No_Artifacts_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_list_no_artifacts_title = /** @type {((inputs?: Artifact_List_No_Artifacts_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_List_No_Artifacts_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Artefakte")
	return /** @type {LocalizedString} */ ("No artifacts yet")
});